import {Pipe, PipeTransform} from '@angular/core';
@Pipe({name: 'breadText'})
export class BreadTextTransform implements PipeTransform {
  transform(text) {
    if (text === 'myFitList') {
      return 'MyFit List';
    } else {
      return text.split(/(?=[A-Z])/).join(' ');
    }

  }
}
